import { EnvironmentBanner } from '@components/features/Layout/EnvironmentBanner';
import { LayoutFooter } from '@components/features/Layout/Footer';
import { LayoutNavigation } from '@components/features/Layout/Navigation';
import { Sandbox } from '@components/features/Sandbox';

import { LayoutBackButton } from './LayoutBackButton';
import LayoutBody from './LayoutBody';
import LayoutLoader from './LayoutLoader';
import LayoutOutlet from './LayoutOutlet';

import css from './Layout.module.css';

type LayoutProps = {
  children: React.ReactNode;
};

function Layout({ children }: LayoutProps) {
  return (
    <div className={css.root}>
      <EnvironmentBanner />
      <Sandbox.Banner />
      <div className={css.rootContent}>{children}</div>
    </div>
  );
}

Layout.Navigation = LayoutNavigation;
Layout.Footer = LayoutFooter;
Layout.Outlet = LayoutOutlet;
Layout.Body = LayoutBody;
Layout.Loader = LayoutLoader;
Layout.BackButton = LayoutBackButton;

export default Layout;
